import apiFinanzas from './apiBase'

/**
 * Servicio para Categorías Financieras
 */
export const categoriasServicio = {
  /**
   * Listar todas las categorías
   */
  async listar(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/categorias', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al listar categorías:', error)
      throw error
    }
  },

  /**
   * Obtener una categoría por ID
   */
  async obtener(id) {
    try {
      const response = await apiFinanzas.get(`/finanzas/categorias/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al obtener categoría:', error)
      throw error
    }
  },

  /**
   * Crear nueva categoría
   */
  async crear(datos) {
    try {
      const response = await apiFinanzas.post('/finanzas/categorias', datos)
      return response.data || response
    } catch (error) {
      console.error('Error al crear categoría:', error)
      throw error
    }
  },

  /**
   * Actualizar categoría
   */
  async actualizar(id, datos) {
    try {
      const response = await apiFinanzas.put(`/finanzas/categorias/${id}`, datos)
      return response.data || response
    } catch (error) {
      console.error('Error al actualizar categoría:', error)
      throw error
    }
  },

  /**
   * Eliminar categoría
   */
  async eliminar(id) {
    try {
      const response = await apiFinanzas.delete(`/finanzas/categorias/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al eliminar categoría:', error)
      throw error
    }
  }
}

export default categoriasServicio
